/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-checklist[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:2rem}.document-checklist[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:1.5rem}.document-checklist[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:1.25rem}.document-checklist[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{font-size:inherit;font-weight:500}"];
export { styles as styles };
